<template>
<span :class="link.style">
  <a :href="link.url" target="_blank">{{link.title}} </a>
</span>
</template>

<script>
export default {
  name: "Link",
  props: ["link"]
};
</script>
